import global from './global-variables';
import $ from 'jquery';
window.jQuery = $;
import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';
import './vendor/jquery.validate.min.js';
import './vendor/additional-methods.min.js';

const body = document.querySelector('body');
const emailMeModal = document.querySelector('.modal-email-me');
const emailMeModalEmail = document.querySelector('.modal-email-me');

/**
 * Initializes the confirmation modal
 * This modal is triggered by the continue button click from 
 * email me modal
 */
const confirmationModalHooks = {
  _hasScrolledToBottom: false,
  _addModalError: function (target) { 
  },
  _removeModalError: function (target) { },
  beforeOpen: function (target) {
    const email = emailMeModal.querySelector('#emailme-email').value;
    target.querySelector('.email-me-confirmation--address').textContent = email;
    PL_utils.addClass('modal-open', body);
  },
  afterOpen: function (target) { },
  onContinue: function (e, target) {
  },
  onCancel: function () {
    return false;
  },
  beforeClose: function () {
    return false;
  },
  afterClose: function () {
    console.log('closing');
    var el = document.querySelector('[data-email-me]');
    if (el) {
      el.focus();
    }
    PL_utils.removeClass('modal-open', body);
  },
  setSize: function () {
    return false;
  },
  onScreenshot: function () {
    return false;
  },
  onInit: function (target) { }
};

const modalOpts = {
  enableBackdropClose: true
};

const emailMeModalClose = emailMeModal.querySelector('.modal__cancel');
const emailMeConfirmationModalEle = document.querySelector('.modal-emailme-confirmation');
const emailMeConfirmationModal = modal.initModal(emailMeConfirmationModalEle, confirmationModalHooks, modalOpts);

export default (FindTreatmentProviderResult) => {
  $('#email-me-form').validate({
    focusInvalid: false,
    rules: {
      eligibility: {
        required: true
      },
      email: {
        required: true,
        pattern: "^(([0-9a-zA-Z])+([-._\\'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$",
      },
      'emailme-option': {
        required: true
      }
    },
    showErrors: function (errorMap, errorList) {
      // The arguments in errorList contain only those elements currently validated.
      // Refer to the form.successList for all the valid field,
      // and remove the error message that's associated to it.
      // Ref: https://jqueryvalidation.org/validate/  => showErrors
      const outputErr = [];
      this.successList.forEach((e) => {
        const targetName = e.name;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error`);

        $(targetElements).removeClass('error');
        errorElement.addClass('hidden');
      });

      const allErrorElement = $('#all-fields-required-error .form-error');
      errorList.forEach((error) => {
        const targetName = error.element.name;
        const { method } = error;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error.error-${method}`);
        const errorMessage = $(`#${targetName}-label .form-error.error-${method} span`);

        targetElements.addClass('error');
        errorElement.removeClass('hidden');
        allErrorElement.removeClass('hidden');

        var errorsArr = targetName + " - " + errorMessage.text();

        outputErr.push(errorsArr);
      });

      var submitData = {
        formName: "email-me-form",
        errors: outputErr
      }
      window.eventsManager.emit('invalidForm', submitData);
    },
    invalidHandler: function() {
      const allErrorElement = $('#all-fields-required-error');
      setTimeout(()=> {
        allErrorElement.focus(); 
      }, 100); 
    },
    submitHandler: function (form) {
      //Show loading icon
      document.querySelector('.modal-email-me .svg--icon-loading').classList.remove('hidden');

      //Submit the form
      const formData = $(form).serializeArray();
      const searchParams = FindTreatmentProviderResult.getSearchParams();

      const postData =  {
        source_name: 'sublocade_patient_fatp_signup',
        results: FindTreatmentProviderResult.getVisibleData().slice(0, 10).map(function (d) {
          return {
            Address1: d.Address1,
            Address2: d.Address2,
            City: d.City,
            Distance: d.Distance,
            DistanceIndex: d.DistanceIndex,
            PracticeName: d.PracticeName,
            FirstName: d.FirstName,
            FullAddress: d.FullAddress,
            LastName: d.LastName,
            Lat: d.Lat,
            Lng: d.Lng,
            NicePhone: d.NicePhone,
            Phone: d.Phone,
            State: d.State,
            ZipCode: d.ZipCode,
            coordHash: d.coordHash,
          };
        }),
      };

      formData.forEach(function (field) {
        postData[field.name] = field.value;
      });

      $.ajax(global.API_ENDPOINT + "/fatp/signup", {
        data: JSON.stringify(postData),
        dataType: 'json',
        method: 'POST'
      })
        .done(function (resp) {
          if (resp.success) {
            window.eventsManager.emit('validForm', { formName: "email-me-form" });
            emailMeConfirmationModal.showModal(); // This has to show modal before closing other modal because it needs to transfer email address
            emailMeModalClose.click();
            document.querySelector('.modal-email-me .svg--icon-loading').classList.add('hidden'); //Hide loading icon
            emailMeConfirmationModalEle.focus();
          } else {
            console.error(JSON.stringify(resp));
            if (!window.debug) {
              window.location.href = "/404";
            }
          }
        })
        .fail(function (err) {
          console.error(JSON.stringify(err));
          if (!window.debug) {
            window.location.href = "/404";
          }
        })
    }
  });

  //screenshot
  if (window.location.search.substring(1).split('&').indexOf('modal=confirmation') > -1) {
    emailMeConfirmationModal.showModal();
    emailMeConfirmationModalEle.querySelector('.email-me-confirmation--address').textContent = 'test@test.com';
  }
}
